import { memo } from 'react';
import { SliderArrow, type SliderWithArrowProps } from '../../helpers';
import { CustomArrows } from './CustomArrows';
import { InsideArrows } from './InsideArrows/InsideArrows';
import { OutsideArrows } from './OutsideArrows/OutsideArrows';

interface IArrowsProps {
  arrows: SliderWithArrowProps;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  isEnd: boolean;
  isBeginning: boolean;
  isOne: boolean;
  hideArrows: boolean;
  loop?: boolean;
}

export const Arrows = memo(
  ({
    arrows,
    handlePrevClick,
    handleNextClick,
    isEnd,
    isBeginning,
    isOne,
    hideArrows,
    loop,
  }: IArrowsProps) => {
    switch (arrows.type) {
      case SliderArrow.OUTSIDE:
        return (
          <OutsideArrows
            dark={arrows.dark}
            handleNextClick={handleNextClick}
            handlePrevClick={handlePrevClick}
            isBeginning={isBeginning}
            isEnd={isEnd}
            leftComponent={arrows.componentLeft}
            rightComponent={arrows.componentRight}
            visibleForMobile={arrows.visibleForMobile}
          />
        );
      case SliderArrow.INSIDE:
        return (
          <InsideArrows
            handleNextClick={handleNextClick}
            handlePrevClick={handlePrevClick}
            hideArrows={hideArrows}
            insetLeftArrow={arrows.insetLeftArrow}
            insetRightArrow={arrows.insetRightArrow}
            isBeginning={isBeginning}
            isEnd={isEnd}
            isOne={isOne}
            loop={loop}
            visibleForMobile={arrows.visibleForMobile}
          />
        );
      case SliderArrow.CUSTOM:
        return (
          <CustomArrows
            componentLeft={arrows.componentLeft}
            componentRight={arrows.componentRight}
            handleNextClick={handleNextClick}
            handlePrevClick={handlePrevClick}
          />
        );
      default:
        return null;
    }
  }
);
